function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import './CommonModal.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CommonModal = function CommonModal(props) {
  useEffect(function () {
    if (props.isOpen) {
      setIsModalOpen(true);
    }
  }, [props]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var modalClasses = ["modal", "fade", "change_code"];
  if (isModalOpen == true) {
    modalClasses.push('show');
    modalClasses.push('m-display-block');
  }
  var close = function close() {
    setIsModalOpen(false);
    props.onClose();
  };
  var success = function success() {
    setIsModalOpen(false);
    props.onSuccess();
  };
  return /*#__PURE__*/_jsx("div", {
    className: modalClasses.join(' '),
    id: "change_code",
    children: /*#__PURE__*/_jsx("div", {
      className: "modal-dialog modal-dialog-centered",
      children: /*#__PURE__*/_jsxs("div", {
        className: "modal-content",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "modal-header",
          children: [/*#__PURE__*/_jsx("h5", {
            className: "modal-title text-center",
            children: "Confirmation"
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "close",
            onClick: close,
            children: "\u2715"
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "modal-body",
          children: /*#__PURE__*/_jsxs("div", {
            className: "ws_confirm",
            children: [/*#__PURE__*/_jsx("div", {
              className: "ws_confirm_icon",
              children: /*#__PURE__*/_jsx("i", {
                "data-feather": "info"
              })
            }), /*#__PURE__*/_jsx("h3", {
              className: "text_center",
              children: "Are you sure you want to remove? "
            })]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "modal-footer",
          children: [/*#__PURE__*/_jsx("a", {
            className: "ws_btn ws_btn_sm ws_btn_black ws_btn_auto changecode",
            onClick: success,
            children: "Yes"
          }), /*#__PURE__*/_jsx("button", {
            className: "ws_btn ws_btn_sm ws_btn_auto",
            onClick: close,
            children: "No"
          })]
        })]
      })
    })
  });
};
export default CommonModal;